let trippinModulePromise = null;

async function getTrippinModule() {
  if (!trippinModulePromise) {
    trippinModulePromise = import("../components/TrippinPost/index.js");
  }
  return trippinModulePromise;
}

export async function unmountTrippinOverlay() {
  try {
    const mod = await getTrippinModule();
    if (typeof mod?.unmount === "function") {
      mod.unmount();
    }
  } catch (_) {
    // no-op
  }
}
